<template>
  <roe-error-message :field="design.profit_sharing_amount_percent">
    <roe-percent-input
      type="number"
      v-model.number="design.$model.profit_sharing_amount_percent"
      required
    ></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
export default {
  name: "RoeEmployerOtherCompensationPercentInput",
  components: { RoePercentInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
